module.exports = __webpack_public_path__ + "img/aktuelles_spielgruppenjahr202122.126a9c5b.jpg";